export const messages = {
  label: {
    old: {
      id: 'updatePassword.Form.Label.Old',
      defaultMessage: 'Current password',
    },
    new: {
      id: 'updatePassword.Form.Label.New',
      defaultMessage: 'New password',
    },
    confirmNew: {
      id: 'updatePassword.Form.Label.ConfirmNew',
      defaultMessage: 'Confirm new password',
    },
  },
  intro: {
    label: {
      id: 'updatePassword.Form.Label.Introduction',
      defaultMessage:
        `Before continuing, your password must be changed.
        Your new password should be different than your current one.`,
    },
  },
  updatePassword: {
    label: {
      id: 'updatePassword.Form.Button.UpdatePassword',
      defaultMessage: 'Change Password',
    },
  },
  error: {
    rules: {
      id: 'updatePassword.Form.Error.Rules',
      defaultMessage: 'Password does not meet security requirements.',
    },
    oldPassword: {
      id: 'updatePassword.Form.Error.OldPassword',
      defaultMessage: 'We didn\'t recognize that password. Please try again.',
    },
  },
};
